import { useEffect, useState } from "react";

import { getFrontendTranslations, getPreferredLanguage } from "../lib/i18n";

import type { FrontendLanguage, FrontendTranslations } from "common/i18n/frontend/translations";

export const useTranslations = (): { translations: FrontendTranslations; language: FrontendLanguage } => {
  const initial = getPreferredLanguage();
  const [language, setLanguage] = useState<FrontendLanguage>(initial);
  const [translations, setTranslations] = useState<FrontendTranslations>(getFrontendTranslations(initial));

  useEffect(() => {
    const handler = () => {
      const lang = getPreferredLanguage();

      setLanguage(lang);
      setTranslations(getFrontendTranslations(lang));
    };

    window.addEventListener(`languagechange`, handler);

    return () => {
      window.removeEventListener(`languagechange`, handler);
    };
  }, []);

  return { translations, language };
};
